const initialCaseState = {
    hospitalizationDetails: {},
    tariffListDetails: {},
    ipdRegisterDetails: {},
    hospitalBillDetails: {},
    paymentReceiptDetails: {},
    otRegisterDetails: {},
    icpDetails: {},
    hospitalVisitDetails: {},
    generalRemarksDetails: {},
    loadingCaseHospital: false,
    errorsCaseHospital: {}
}

const CaseHospitalReducer = (state = initialCaseState, action) => {
    switch (action.type) {
        case "ADD_CASE_HOSPITAL_PENDING":
        case "ADD_CASE_TARIFF_LIST_PENDING":
        case "ADD_CASE_IPD_REGISTER_PENDING":
        case "ADD_CASE_HOSPITAL_BILL_PENDING":
        case "ADD_CASE_PAYMENT_RECEIPT_PENDING":
        case "ADD_CASE_OT_REGISTER_PENDING":
        case "ADD_CASE_ICP_DETAILS_PENDING":
        case "ADD_CASE_HOSPITAL_VISIT_PENDING":
        case "ADD_CASE_HOSPITAL_GENERAL_REMARKS_PENDING":
            return { ...state, loading: true };

        case "ADD_CASE_HOSPITAL_FULFILLED":
            return {
                ...state,
                loadingCaseHospital: false,
                hospitalizationDetails: action.payload,
                errorsCaseHospital: {}
            };
        case "ADD_CASE_TARIFF_LIST_FULFILLED":
            return {
                ...state,
                loadingCaseHospital: false,
                tariffListDetails: action.payload,
                errorsCaseHospital: {}
            };
        case "ADD_CASE_IPD_REGISTER_FULFILLED":
            return {
                ...state,
                loadingCaseHospital: false,
                ipdRegisterDetails: action.payload,
                errorsCaseHospital: {}
            };
        case "ADD_CASE_HOSPITAL_BILL_FULFILLED":
            return {
                ...state,
                loadingCaseHospital: false,
                hospitalBillDetails: action.payload,
                errorsCaseHospital: {}
            };
        case "ADD_CASE_PAYMENT_RECEIPT_FULFILLED":
            return {
                ...state,
                loadingCaseHospital: false,
                paymentReceiptDetails: action.payload,
                errorsCaseHospital: {}
            };
        case "ADD_CASE_OT_REGISTER_FULFILLED":
            return {
                ...state,
                loadingCaseHospital: false,
                otRegisterDetails: action.payload,
                errorsCaseHospital: {}
            };
        case "ADD_CASE_ICP_DETAILS_FULFILLED":
            return {
                ...state,
                loadingCaseHospital: false,
                icpDetails: action.payload,
                errorsCaseHospital: {}
            };
        case "ADD_CASE_HOSPITAL_VISIT_FULFILLED":
            return {
                ...state,
                loadingCaseHospital: false,
                hospitalVisitDetails: action.payload,
                errorsCaseHospital: {}
            };
        case "ADD_CASE_HOSPITAL_GENERAL_REMARKS_FULFILLED":
            return {
                ...state,
                loadingCaseHospital: false,
                generalRemarksDetails: action.payload,
                errorsCaseHospital: {}
            };

        case "ADD_CASE_HOSPITAL_REJECTED":
        case "ADD_CASE_TARIFF_LIST_REJECTED":
        case "ADD_CASE_IPD_REGISTER_REJECTED":
        case "ADD_CASE_HOSPITAL_BILL_REJECTED":
        case "ADD_CASE_PAYMENT_RECEIPT_REJECTED":
        case "ADD_CASE_OT_REGISTER_REJECTED":
        case "ADD_CASE_ICP_DETAILS_REJECTED":
        case "ADD_CASE_HOSPITAL_VISIT_REJECTED":
        case "ADD_CASE_HOSPITAL_GENERAL_REMARKS_REJECTED":
            return {
                ...state,
                loadingCaseHospital: false,
                errorsCaseHospital: action.payload
            };

        case "RESET_CASE_HOSPITAL_ERRORS":
            return {
                ...state,
                errorsCaseHospital: {}
            };

        case "RESET_HOSPITALIZATION_DETAILS":
            return {
                ...state,
                hospitalizationDetails: {}
            };

        case "RESET_TARIFF_LIST_DETAILS":
            return {
                ...state,
                tariffListDetails: {}
            };

        case "RESET_IPD_REGISTER_DETAILS":
            return {
                ...state,
                ipdRegisterDetails: {}
            };

        case "RESET_HOSPITAL_BILL_DETAILS":
            return {
                ...state,
                hospitalBillDetails: {}
            };

        case "RESET_PAYMENT_RECEIPT_DETAILS":
            return {
                ...state,
                paymentReceiptDetails: {}
            };

        case "RESET_OT_REGISTER_DETAILS":
            return {
                ...state,
                otRegisterDetails: {}
            };

        case "RESET_ICP_DETAILS":
            return {
                ...state,
                icpDetails: {}
            };

        case "RESET_HOSPITAL_VISIT_DETAILS":
            return {
                ...state,
                hospitalVisitDetails: {}
            };

        case "RESET_HOSPITAL_GENERAL_REMARKS_DETAILS":
            return {
                ...state,
                generalRemarksDetails: {}
            };

        default:
            return state;
    }
}

export default CaseHospitalReducer; 